export interface ILocaleState {
  readonly currentLocale: string;
  readonly allMessages: any;
}

const initialState: ILocaleState = {
  currentLocale: 'en',
  allMessages: {
    en: {},
    de: {},
  },
};

import * as actions from './actions';
import { ActionType, getType } from 'typesafe-actions';

type LocaleActions = ActionType<typeof actions>;

export default (state: ILocaleState = initialState, action: LocaleActions): ILocaleState => {
  switch (action.type) {
    case getType(actions.localeSettingsChangeLocale): {
      return { ...state, currentLocale: action.payload };
    }
    case getType(actions.localeSettingsLoadMessages): {
      return { ...state, allMessages: { ...state.allMessages, ...action.payload } };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/LocaleSettings/reducer.ts